import TypesenseInstantSearchAdapter from "typesense-instantsearch-adapter";
import { getTypesenseConfig } from "../config/typesenseConfig";

export function createSearchClient() {
    const config = getTypesenseConfig();
    if (!config) return null;

    const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
        server: {
            apiKey: config.apiKey,
            nodes: [
                {
                    host: config.host,
                    port: config.port,
                    path: "",
                    protocol: config.protocol,
                },
            ],
            cacheSearchResultsForSeconds: 2,
        },
        // typesense vereist alle query-tokens binnen één veld; multi-woord queries matchen
        // daarom op gecombineerde velden (full_name, name, keywords, content).
        // drop_tokens_threshold: 1 werkt als pure fallback: pas als een query nul resultaten
        // heeft laat typesense tokens vallen ("Mercedes A-Klasse" toont dan toch de
        // Mercedes-vestigingen). hoger zetten introduceert ruis van losse-token-matches
        collectionSpecificSearchParameters: {
            [config.collections.vehicles]: {
                query_by: 'full_name,brand,model,type,license_plate,fuel,bodywork,options',
                query_by_weights: '5,4,4,3,2,1,1,1',
                drop_tokens_threshold: 1,
                num_typos: 1
            },
            [config.collections.pages]: {
                query_by: 'title,search_terms,tags,brand,model,description,content,url',
                query_by_weights: '5,4,3,3,3,2,1,1',
                drop_tokens_threshold: 1,
                num_typos: 1
            },
            ...(config.collections.establishments && {
                [config.collections.establishments]: {
                    query_by: 'name,title,brands,keywords,categories,search_terms',
                    query_by_weights: '5,3,4,3,2,2',
                    drop_tokens_threshold: 1,
                    num_typos: 1
                }
            }),
            ...(config.collections.wpp && {
                [config.collections.wpp]: {
                    query_by: 'title,brand,description',
                    query_by_weights: '4,5,1',
                    drop_tokens_threshold: 1,
                    num_typos: 1
                }
            })
        }
    });

    const originalSearchClient = typesenseInstantsearchAdapter.searchClient;

    return {
        ...originalSearchClient,
        search(requests) {
            const hasQuery = requests.some(
                request => request.params && request.params.query && request.params.query.trim() !== ''
            );

            if (!hasQuery) {
                return Promise.resolve({
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        page: 0,
                        nbPages: 0,
                        hitsPerPage: 20,
                        processingTimeMS: 0,
                        query: '',
                        params: ''
                    }))
                });
            }

            return originalSearchClient.search(requests).catch((error) => {
                console.error('Typesense search error:', error);

                if (window.__searchErrorToast) {
                    window.__searchErrorToast();
                }

                return {
                    results: requests.map(() => ({
                        hits: [],
                        nbHits: 0,
                        page: 0,
                        nbPages: 0,
                        hitsPerPage: 20,
                        processingTimeMS: 0,
                        query: '',
                        params: ''
                    }))
                };
            });
        }
    };
}
